import { render, staticRenderFns } from "./file.vue?vue&type=template&id=9d62f620&scoped=true&"
import script from "./file.vue?vue&type=script&lang=js&"
export * from "./file.vue?vue&type=script&lang=js&"
import style0 from "./file.vue?vue&type=style&index=0&id=9d62f620&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d62f620",
  null
  
)

export default component.exports